export default {"src":"/_next/static/media/clipboardWithWave_64.15a59322.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};